import type { SvgProps } from '../types';

export const Checkmark = ({ size = 16, color = 'currentcolor' }: SvgProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path fill={color} d="m9.085 15.525-3.793-3.793L4 13.014l5.085 5.085L20 7.184l-1.283-1.283z" fillRule="evenodd" />
  </svg>
);
